import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import OrganizationSettingsContainer from '../../containers/organizations/OrganizationSettingsContainer.jsx';

const CustomSettings = () => (
  <>
    <Helmet>
      <title>Organization Settings | ChangeSync</title>
    </Helmet>
    <OrganizationSettingsContainer />
  </>
);

export default requireAuth(withRouterParams(CustomSettings));
